import * as React from 'react';

export default function AppFooter() {
    return (
        <footer className="footer">
            <div className="footer__copy">(c) mwd - marburg webdesign</div>
        </footer>
    );
}
